/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignProgramToPortfolioCommand } from '../../models/assign-program-to-portfolio-command';
import { AssignProgramToPortfolioCommandResult } from '../../models/assign-program-to-portfolio-command-result';

export interface ApiProgramAssignAndUnAssignProgramToPortfolioPost$Plain$Params {
      body?: AssignProgramToPortfolioCommand
}

export function apiProgramAssignAndUnAssignProgramToPortfolioPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProgramAssignAndUnAssignProgramToPortfolioPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignProgramToPortfolioCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProgramAssignAndUnAssignProgramToPortfolioPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AssignProgramToPortfolioCommandResult>;
    })
  );
}

apiProgramAssignAndUnAssignProgramToPortfolioPost$Plain.PATH = '/api/Program/AssignAndUnAssignProgramToPortfolio';
